import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'idFormat',
    pure: true,
    standalone: false
})
export class IdFormatPipe implements PipeTransform {
  transform(row: any, ...args: unknown[]): string {
    if (row && row.id) {
      return row.id.substring(0, 8);
    }
    return '';
  }
}